/**
 * Private modules
 */
const {
  alias,
  createQueryComponent,
  customerId,
  layouts,
  objectId,
  objectIds,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createCustomerRunnerTicketConversionBySystemGameId: {
    properties: {
      body: {
        properties: {
          alias,
          layouts,
        },
        required: [
          'alias',
          'layouts',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteCustomerRunnerTicketConversionsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRunnerTicketConversionsBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerRunnerTicketConversionById: {
    properties: {
      body: {
        properties: {
          alias,
        },
        required: ['alias'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
